var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',[_c('div',{staticClass:"header"},[_c('span',{on:{"click":function($event){return _vm.$router.back(-1)}}},[_c('i',{staticClass:"cubeic-back"})]),_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.videoInfo.title)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }